/** Shared cadence for visible resource publish-job status reads. */
export const PUBLISH_JOB_POLL_INTERVAL_MS = 5000;
